export default {
  newInsurancePolicy: ({ newInsurancePolicy }) => newInsurancePolicy,
  increaseInsurableRisk: ({ increaseInsurableRisk }) => increaseInsurableRisk,
  reductionOfInsurableValue: ({ reductionOfInsurableValue }) => reductionOfInsurableValue,
  movementWithoutPremium: ({ movementWithoutPremium }) => movementWithoutPremium,
  changeOfShare: ({ changeOfShare }) => changeOfShare,
  internalAdjustment: ({ internalAdjustment }) => internalAdjustment,
  endorsementsSummary: ({ endorsementsSummary }) => endorsementsSummary,
  endorsements: ({ endorsements }) => endorsements,
  movementsList: ({ movementsList }) => movementsList,
  endorsementsDocuments: ({ endorsementsDocuments }) => endorsementsDocuments,
};
